<div class="resume-page" *ngIf="ready && summary">
  <div class="resume-card">
    <div class="resume-summary">
      <div class="resume-summary__item">
        <h6>Producto</h6>
        <h3>{{ summary.product }}</h3>
      </div>

      <div class="resume-summary__item">
        <h6>Cantidad</h6>
        <h3>{{ summary.quantity }} {{ summary.quantityUnit }}</h3>
      </div>

      <div class="resume-summary__item resume-summary__item--amount">
        <h6>Monto a pagar</h6>
        <h1>{{ summary.amount | currency:'$ ':'symbol':'.0':'es' }}</h1>
      </div>

      <div class="resume-summary__item">
        <h6>Dirección de despacho</h6>
        <h4>{{ summary.dispatchComuna }}, {{ summary.dispatchRegion }}</h4>
      </div>

      <div class="resume-summary__item">
        <h6>Fecha de entrega</h6>
        <h4>{{ summary.deliveryDate | date:'fullDate':'':'es-CL' }}</h4>
        <h6 *ngIf="summary.deliveryWindow">{{ summary.deliveryWindow }}</h6>
      </div>
    </div>

    <div class="resume-payment">
      <h2>Seleccione tu medio de pago</h2>

      <div class="alert alert-primary" role="alert">
        Para garantizar que el pago se procese correctamente, por favor presione el botón
        <strong>Volver a comercio</strong> al finalizar.
      </div>

      <div class="resume-payment__options" role="radiogroup" aria-label="Medios de pago">
        <button
          *ngFor="let provider of paymentProviders"
          type="button"
          class="resume-payment__option"
          [class.resume-payment__option--selected]="selectedPaymentProvider === provider.id"
          [attr.aria-checked]="selectedPaymentProvider === provider.id"
          role="radio"
          (click)="selectPaymentProvider(provider.id)">
          <span class="resume-payment__radio" aria-hidden="true"></span>
          <img [src]="provider.logo" [alt]="provider.name" class="resume-payment__logo">
          <span class="resume-payment__description">{{ provider.description }}</span>
        </button>
      </div>

      <label class="resume-payment__terms">
        <input type="checkbox" [(ngModel)]="acceptTerms" name="acceptTerms">
        <span>Acepto los términos y condiciones</span>
      </label>

      <button
        type="button"
        class="btn btn-secondary resume-payment__continue"
        [disabled]="!acceptTerms"
        (click)="continuePayment()">
        Continuar
      </button>
    </div>
  </div>
</div>
